import { arrayUnion, doc, runTransaction } from 'firebase/firestore';

import { auth, db } from './firebase';

export const CLASS_SIZE_LIMIT = 30;

// Firestore document ids, so a "/" or odd characters can never reach the path
const CODE_PATTERN = /^[A-Za-z0-9_-]{3,40}$/;

// Resolves to { ok: true, alreadyJoined } or { ok: false, reason }.
// reason: 'signed-out' | 'invalid' | 'not-found' | 'full' | 'already-premium' | 'denied' | 'error'
export const redeemClassCode = async (rawCode) => {
  const code = (rawCode || '').trim();
  const user = auth.currentUser;
  if (!user) return { ok: false, reason: 'signed-out' };
  if (!CODE_PATTERN.test(code)) return { ok: false, reason: 'invalid' };

  const licenseRef = doc(db, 'licenses', code);
  const userRef = doc(db, 'users', user.uid);

  try {
    // A transaction, so two students grabbing the last seat at once can't both get it
    return await runTransaction(db, async (tx) => {
      const licenseSnap = await tx.get(licenseRef);
      const userSnap = await tx.get(userRef);

      if (!licenseSnap.exists()) return { ok: false, reason: 'not-found' };

      const students = (licenseSnap.data() || {}).students || [];
      const alreadyJoined = students.includes(user.uid);
      const status = userSnap.exists() ? userSnap.data().membershipStatus : 'Basic';

      // Already paying? Don't spend a seat or touch their plan.
      if (status && status !== 'Basic' && !alreadyJoined) {
        return { ok: false, reason: 'already-premium' };
      }
      if (!alreadyJoined && students.length >= CLASS_SIZE_LIMIT) {
        return { ok: false, reason: 'full' };
      }

      if (!alreadyJoined) tx.update(licenseRef, { students: arrayUnion(user.uid) });
      tx.set(userRef, { membershipStatus: 'Premium', classCode: code }, { merge: true });
      return { ok: true, alreadyJoined };
    });
  } catch (e) {
    console.error('Class code failed', e);
    return { ok: false, reason: e && e.code === 'permission-denied' ? 'denied' : 'error' };
  }
};